import { Navigate } from 'react-router-dom';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PatientPortalSystemOptions } from 'types/patient-portal-system.types';

export const TenantGuard = ({
  allowedTenantId,
  children,
}: {
  allowedTenantId: PatientPortalSystemOptions;
  children: React.ReactElement;
}): React.ReactElement => {
  const { systemId } = usePatientPortalContext();

  if (systemId !== allowedTenantId) {
    return <Navigate to={APP_MANAGED_ROUTES.HOME} replace />;
  }

  return children;
};
